export default __webpack_public_path__ + "static/retention-dark-522c92abad86910d70e43334e906793e.png";